// A single slot in the top nav that month-scoped routes fill with the MonthNav
// (so the switcher lives in the header bar, consistent across dashboard /
// transactions / budgets). Non-month routes clear it. app.ts registers the slot
// element once; each route sets or clears it on entry.
let slot: HTMLElement | null = null;

export function registerHeaderSlot(el: HTMLElement): void {
	slot = el;
}

export function setHeaderControl(node: Node | null): void {
	if (!slot) return;
	slot.replaceChildren(...(node ? [node] : []));
}
